import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  subtitle?: string;
  size?: 'default' | 'compact';
  showArrow?: boolean;
  className?: string;
}
export function CTAButton({
  text = 'ORDER CROWNCONTROL™ — $497',
  subtitle = '180-Day Guarantee  ·  Free Shipping  ·  Order Risk-Free',
  size = 'default',
  showArrow = false,
  className = ''
}: CTAButtonProps) {
  const isCompact = size === 'compact';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-16">
      <button onClick={() => window.open('https://gogurlhoop.shop/checkouts/cn/hWN8w1extOgmGlbld4thOILK/en-us?_r=AQAByBvaKgWh4yuHmNpwXB8WBiSBVxx0XL7Jqt9qn0-QWv0&auto_redirect=false&edge_redirect=true&skip_shop_pay=true', '_blank')} className={`
          group relative overflow-hidden
          bg-[#C8A04A] text-[#0A0A0A] font-bold tracking-wide
          rounded transition-all duration-300
          hover:bg-[#D4AF37] hover:shadow-[0_0_30px_rgba(200,160,74,0.3)]
          active:scale-[0.98]
          cursor-pointer
          ${isCompact ? 'px-6 py-3 text-sm' : 'px-10 py-5 text-base md:text-lg'}
        `} data-id="element-17">
        <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-18">
          {text}
          {showArrow && <ArrowRightIcon className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-19" />}
        </span>
      </button>
      {subtitle && !isCompact && <p className="mt-3 text-sm text-[#9CA3AF] tracking-wide" data-id="element-20">{subtitle}</p>}
    </div>;
}